module.exports = __webpack_public_path__ + "img/20191202174107360截图20191202170136847.0fc82e95.jpg";